import { formatNumberOrStringValue } from '../../utilities/helpers.mjs';
import { PopoverCssProperty } from '../../types/style.mjs';

function distanceToRight(rightPosition, containerWidth) {
  return containerWidth ? containerWidth - rightPosition : undefined;
}
function distanceToBottom(bottomPosition, containerHeight) {
  return containerHeight ? containerHeight - bottomPosition : undefined;
}
function domRectToLayout(rect, container) {
  const {
    top,
    right,
    bottom,
    left,
    width,
    height
  } = rect;
  return {
    top,
    right,
    bottom,
    left,
    width,
    height,
    distanceRight: distanceToRight(right, container == null ? void 0 : container.width),
    distanceBottom: distanceToBottom(bottom, container == null ? void 0 : container.height)
  };
}
function mergePopoverLayouts(...layouts) {
  return layouts.reduce((obj, item) => ({
    ...obj,
    ...item
  }), {});
}
function popoverLayoutToCss({
  zIndex,
  position,
  top,
  right,
  bottom,
  left,
  width,
  minWidth,
  maxWidth,
  height,
  minHeight,
  maxHeight,
  transition
}) {
  const properties = {
    [PopoverCssProperty.ZIndex]: zIndex,
    [PopoverCssProperty.Position]: position,
    [PopoverCssProperty.Top]: formatNumberOrStringValue(top),
    [PopoverCssProperty.Right]: formatNumberOrStringValue(right),
    [PopoverCssProperty.Bottom]: formatNumberOrStringValue(bottom),
    [PopoverCssProperty.Left]: formatNumberOrStringValue(left),
    [PopoverCssProperty.Width]: formatNumberOrStringValue(width),
    [PopoverCssProperty.MinWidth]: formatNumberOrStringValue(minWidth),
    [PopoverCssProperty.MaxWidth]: formatNumberOrStringValue(maxWidth),
    [PopoverCssProperty.Height]: formatNumberOrStringValue(height),
    [PopoverCssProperty.MinHeight]: formatNumberOrStringValue(minHeight),
    [PopoverCssProperty.MaxHeight]: formatNumberOrStringValue(maxHeight),
    [PopoverCssProperty.Transition]: formatNumberOrStringValue(transition)
  };
  return filterUndefinedProperties(properties);
}
function filterUndefinedProperties(properties) {
  return Object.entries(properties).filter(([_, value]) => value !== undefined).reduce((current, [key, value]) => ({
    ...current,
    [key]: value
  }), {});
}

export { domRectToLayout, mergePopoverLayouts, popoverLayoutToCss };
